import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { StravaIcon } from "../components/strava/StravaConnectButton";
import { CheckCircle2, AlertTriangle, ArrowRight } from "lucide-react";

export function StravaCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("processing"); // 'processing' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const error = searchParams.get("error");
    if (error) {
      setStatus("error");
      setErrorMessage(
        error === "access_denied"
          ? "Acesso cancelado no Strava."
          : `Erro de autorização: ${error}`
      );
      return;
    }

    // Sucesso na conexão
    setStatus("success");

    // 1. Caso Popup: Notifica a janela pai e fecha o popup
    if (window.opener && !window.opener.closed) {
      try {
        window.opener.postMessage(
          { type: "STRAVA_AUTH_SUCCESS" },
          window.location.origin
        );
        window.opener.postMessage("STRAVA_AUTH_SUCCESS", "*");
      } catch (err) {
        console.error("Erro ao enviar mensagem para janela principal:", err);
      }

      setTimeout(() => {
        window.close();
      }, 500);
      return;
    }

    // 2. Caso Redirecionamento de Página Inteira (sem popup):
    const timer = setTimeout(() => {
      navigate("/perfil");
    }, 2000);

    return () => clearTimeout(timer);
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center p-6 text-white text-center">
      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-8 max-w-md w-full shadow-2xl flex flex-col items-center gap-5">
        <div className="w-16 h-16 rounded-2xl bg-[#FC4C02]/15 border border-[#FC4C02]/30 flex items-center justify-center text-[#FC4C02]">
          <StravaIcon className="w-8 h-8" />
        </div>

        {status === "processing" && (
          <div>
            <h2 className="text-xl font-bold mb-2">Processando conexão...</h2>
            <p className="text-sm text-slate-400">
              Estamos validando seus dados com o Strava.
            </p>
          </div>
        )}

        {status === "success" && (
          <div>
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold text-emerald-400 bg-emerald-500/10 border border-emerald-500/20 mb-3">
              <CheckCircle2 className="w-4 h-4" />
              <span>Conexão Concluída!</span>
            </div>
            <h2 className="text-xl font-bold mb-2">Strava Conectado</h2>
            <p className="text-sm text-slate-400">
              Sua conta foi vinculada com sucesso. Esta janela será fechada ou
              você será redirecionado em instantes...
            </p>

            <button
              onClick={() => navigate("/perfil")}
              className="mt-6 inline-flex items-center gap-2 text-xs font-semibold text-white bg-slate-800 hover:bg-slate-700 px-4 py-2 rounded-xl transition-colors cursor-pointer"
            >
              <span>Voltar ao Perfil</span>
              <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </div>
        )}

        {status === "error" && (
          <div>
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold text-red-400 bg-red-500/10 border border-red-500/20 mb-3">
              <AlertTriangle className="w-4 h-4" />
              <span>Falha na Conexão</span>
            </div>
            <h2 className="text-xl font-bold mb-2">Não foi possível conectar</h2>
            <p className="text-sm text-slate-400">{errorMessage}</p>

            <button
              onClick={() => {
                if (window.opener) window.close();
                else navigate("/perfil");
              }}
              className="mt-6 inline-flex items-center gap-2 text-xs font-semibold text-white bg-slate-800 hover:bg-slate-700 px-4 py-2 rounded-xl transition-colors cursor-pointer"
            >
              <span>Fechar</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default StravaCallbackPage;
